<script setup lang="ts">

import { AppTable, AppTh, AppTr, AppTd } from '@shared/ui/tables'
import { CardAdmin } from '@shared/ui/cards'

import { useSettingsStore } from '../../model/settings/store'

interface SettingRow {
  key: string
  value: string
}

defineOptions({
  name: 'TableSettings',
})

const settingsStore = useSettingsStore()

const formatValue = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '—'
  }

  if (typeof value === 'string') {
    return value
  }

  return JSON.stringify(value, null, 2)
}

const rows = computed<SettingRow[]>(() =>
  Object.entries(settingsStore.getSettings)
    .map(([key, value]) => ({ key, value: formatValue(value) }))
    .sort((a, b) => a.key.localeCompare(b.key)),
)
</script>

<template>
  <CardAdmin
    title="Settings"
    fullwidth
  >
    <AppTable
      class="rounded-table"
      :loading="settingsStore.isLoading"
      :paginated="false"
    >
      <template #head>
        <AppTr>
          <AppTh>Key</AppTh>
          <AppTh>Value</AppTh>
        </AppTr>
      </template>
      <template #body>
        <AppTr
          v-for="row in rows"
          :key="row.key"
        >
          <AppTd>{{ row.key }}</AppTd>
          <AppTd>
            <span class="table-settings__value">{{ row.value }}</span>
          </AppTd>
        </AppTr>
        <AppTr v-if="!rows.length">
          <AppTd>No settings configured.</AppTd>
          <AppTd />
        </AppTr>
      </template>
    </AppTable>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./TableSettings.scss" />
